var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"composed--title"},[_c('div',{staticClass:"composed--title__row",domProps:{"innerHTML":_vm._s(_vm.lines[0])}}),_c('div',{staticClass:"w-full"}),_c('div',{staticClass:"composed--title__row",domProps:{"innerHTML":_vm._s(_vm.lines[1])}})])
}
var staticRenderFns = []

export { render, staticRenderFns }